module.exports = __webpack_public_path__ + "static/media/page-8-girl01.cd863ecd.svg";